import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment.prod';
import { BaseAPIClass } from '..';
import { confPaginated } from '@core/constants/paginacion.const';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicioService extends BaseAPIClass {
  // baseUrl = environment.serverBaseUrl;

  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    // this.httpClient = new HttpClient(handler);
    this.baseUrl = '/servicios';
  }

  getAll(term?: any): Observable<any> {
    const filterObject = {
      paginacion: confPaginated.quantity,
      term: term
    };
    return super.getAll(filterObject);
  }

  getHabilitadoTipoServicio(id: any) {
    return this.httpClient.get(this.baseUrl + '/habilitados/tipo/' + id);
  }
}
